import type { HTMLAttributes } from 'react';
import { useSiteContext } from '@eti/providers';
import { getTimeAttributes } from './utils';

interface TimeProps extends Omit<HTMLAttributes<HTMLTimeElement>, 'dateTime'> {
  date: string | number | Date;
  format?: 'datetime' | 'date' | 'time';
}

const Time = ({ children, date, format, ...props }: TimeProps) => {
  const { language } = useSiteContext();

  const { ariaLabel, dateTime } = getTimeAttributes(language.locale, date, format);

  return (
    <time aria-label={ariaLabel} dateTime={dateTime} {...props}>
      {children}
    </time>
  );
};

export default Time;
